import { Paper, Grid, Modal, Typography, Box, Chip, useMediaQuery, useTheme, Popover } from '@mui/material';
import React, { useState, useEffect, useContext } from 'react';
import SearchBar from '../components/SearchBar';
import { AppFilterFields, SelectOptions } from '../../../interfaces/Common';
import JobCard from '../../../Components/JobCards';
import Filters from '../Filters';
import { getJobs, getJobsApply, getJobsBookmark } from '../../../Utils/apiService';
import { AuthUser } from '../../../interfaces/Contexts';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import jobImgNoFilter from '../../../Assets/jobnofilter.png';

const SavedJobs = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [filterData, setFilterData] = useState<AppFilterFields>({});
  const [appliedData, setAppliedData] = useState([]);
  const {
    state: { user },
  } = useContext(AuthContext);
  const userData = user as AuthUser;
  const [allAppliedData, setAllAppliedData] = useState([]);
  const [selectedValues, setSelectedValues] = useState<{ [key: string]: any }>({});
  const [pendingSelectedValues, setPendingSelectedValues] = useState<{ [key: string]: any }>({});
  const [jobFilterData, setJobFilterData] = useState([]);
  const [locations, setLocations] = useState<Array<SelectOptions>>([]);
  const [filter, setFilter] = useState<boolean>(false);
  const [bookmarksData, setBookmarksData] = useState([]);
  const [allBookmarksData, setAllBookmarksData] = useState([]);

  const handleFilterCells = (data: string, key: string) => {
    const filterJobsSaved = allBookmarksData.filter((job: any) => {
      return job[key]?.toLowerCase().includes(data.toLowerCase());
    });
    setBookmarksData(filterJobsSaved);
    setFilterData({ ...filterData, [key]: data });
  };

  const handleChipDelete = (key: string, value: string) => {
    setSelectedValues((prev: any) => {
      const updated = { ...prev };
      if (Array.isArray(updated[key])) {
        updated[key] = updated[key].filter((v: string) => v !== value);
        if (updated[key].length === 0) delete updated[key];
      } else {
        delete updated[key];
      }
      if (key === 'Salary') {
        delete updated['Salary_Start_Range__c'];
        delete updated['Salary_End_Range__c'];
      }
      return updated;
    });
  };

  const getFilteredJobs = () => {
    let filtered = [...allBookmarksData];

    Object.entries(selectedValues).forEach(([key, value]: any) => {
      if (!value || value.length === 0) return;
      if (key === 'Salary') return;
      if (key === 'Organization__r.Name') {
        filtered = filtered.filter((job: any) =>
          value.includes(job.Organization__r?.Name)
        );
      } else if (key === 'Work_Place_Type__c') {
        filtered = filtered.filter((job: any) =>
          job.Work_Place_Type__c && value.some((v: string) => job.Work_Place_Type__c.includes(v))
        );
      } else if (key === 'Posted_by') {
        if (value.includes('myself')) {
          filtered = filtered.filter((job: any) => job.PostedById === userData.applicantId);
        }
      } else if (key === 'Location__c') {
        filtered = filtered.filter((job: any) =>
          value.includes(job.Location__c)
        );
      } else if (key === 'Job_Type__c') {
        filtered = filtered.filter((job: any) =>
          value.includes(job.Job_Type__c)
        );
      } else if (key === 'Skill_Required__c') {
        filtered = filtered.filter((job: any) =>
          job.Skill_Required__c && value.some((v: string) => job.Skill_Required__c.includes(v))
        );
      } else if (key === 'Job_Title__c') {
        filtered = filtered.filter((job: any) =>
          value.includes(job.Job_Title__c)
        );
      } else if (key === 'Industry__c') {
        filtered = filtered.filter((job: any) =>
          value.includes(job.Industry__c)
        );
      }
    });

    if (
      selectedValues.Salary_Start_Range__c &&
      selectedValues.Salary_End_Range__c
    ) {
      filtered = filtered.filter((job: any) => {
        const min = Math.min(...selectedValues.Salary_Start_Range__c);
        const max = Math.max(...selectedValues.Salary_End_Range__c);
        return (
          job.Salary_Start_Range__c >= min &&
          job.Salary_End_Range__c <= max
        );
      });
    }

    return filtered;
  };

  useEffect(() => {
    const filteredJobs = getFilteredJobs();
    setBookmarksData(filteredJobs);
  }, [selectedValues, allBookmarksData]);

  const filterJobs = (jobs: any[], criteria: Record<string, any[]>, name: string) => {
    console.log('Filtering jobs with criteria:', criteria, 'for section:', name);
    setSelectedValues(criteria);
  };

  const handleFilterOpen = () => {
    setPendingSelectedValues(selectedValues);
    setFilter(!filter);

  };

  const handleFilterCancellation = () => {
    setFilterData({});
    setPendingSelectedValues({});
    setFilter(false);
  };

  const handleFilterApply = (newValues: any) => {
    setSelectedValues(newValues);
    setFilter(false);
  };

  const getJobBookmarkDetails = () => {
    getJobsBookmark(userData.applicantId)
      .then((res) => {
        setBookmarksData(res.data.savedJobs);
        setAllBookmarksData(res.data.savedJobs);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getJobDetails = () => {
    getJobs(userData.applicantId)
      .then((res) => {
        setJobFilterData(res.data);
        const locations = res.data.allJobs.map((job: any) => job.Location__c);
        const uniqueLocations: any = Array.from(new Set(locations.filter((location: any) => location !== null)));
        setLocations(uniqueLocations);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    getJobBookmarkDetails();
    getJobDetails();
  }, []);


  const [anchorEl1, setAnchorEl1] = useState<null | HTMLElement>(null);

  const handleSortButtonClick1 = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl1(event.currentTarget);
  };


  return (
    <div>
      {' '}
      <Paper
        sx={{
          marginTop: '-20px',
          height: isMobile ? '100%' : "calc(100vh - 125px) !important",
          boxShadow: 'none',
          borderRadius: 2,
          '@media (min-width: 1280px) and (max-width: 1300px)': {
            height: '82vh !important',
          },
        }}
      >
        <Grid container spacing={2} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
          <Grid item>
            <Typography
              sx={{
                fontSize: '15px',
                fontWeight: 500,
                textAlign: 'left',
                marginLeft: '20px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  fontSize: '12px',
                },
              }}
            >
              Saved Jobs
            </Typography>
          </Grid>
          <Grid item >
            <SearchBar
              handleDropDownChange={(e) => {
                console.log('7657656', e);
                handleFilterCells(e, 'Location__c');
              }}
              handleSearchChange={(e) => {
                console.log('7657656345', e);
                handleFilterCells(e, 'Job_Title__c');
              }}
              searchBarData={{ dropDown: filterData['Location__c'], input: filterData['Job_Title__c'] }}
              dropDownData={locations}
              handleFilter={handleFilterOpen}
              anchorEl1={setAnchorEl1}
            />

            <Popover
              anchorEl={anchorEl1}
              open={filter}
              onClose={handleFilterCancellation}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              PaperProps={{
                sx: {
                  borderRadius: 2,
                  minWidth: 300,
                  boxShadow: 3,
                  mt: 1,
                  backgroundColor: "#FFFFFF",
                  p: 2
                },
              }}
            >
              {/* <Modal open={filter} onClose={handleFilterCancellation} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" BackdropProps={{
                style: { opacity: 0 }
              }}> */}
              <Filters
                handleClose={handleFilterCancellation}
                jobFilterData={jobFilterData}
                selectedValues={pendingSelectedValues}
                setSelectedValues={setPendingSelectedValues}
                handleDropDownChange={handleFilterApply}
              />
              {/* </Modal> */}
            </Popover>
          </Grid>
        </Grid>
        {/* <Typography
          sx={{
            fontSize: '15px',
            fontWeight: 500,
            textAlign: 'left',
            marginLeft: '20px',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              fontSize: '12px',
            },
          }}
        >
          Saved Jobs
        </Typography> */}
        <Box sx={{
          display: 'flex', flexWrap: 'wrap', gap: 1, px: 2,
          mt: 0.7
        }} >
          {Object.entries(selectedValues).map(([key, values]: [string, any]) => {
            if (!values || key.endsWith('_Range__c')) return null;
            if (Array.isArray(values)) {
              return values.map((val: string) => (
                <Chip
                  key={key + val}
                  label={`${key === 'Organization__r.Name' ? 'Company' : key.replace(/__/g, '').replace(/_/g, ' ')}: ${val}`}
                  onDelete={() => handleChipDelete(key, val)}
                  sx={{ fontSize: '12px', m: 0.5 }}
                />
              ));
            }
            return (
              <Chip
                key={key + values}
                label={`${key}: ${values}`}
                onDelete={() => handleChipDelete(key, values)}
                sx={{ fontSize: '12px', m: 0.5 }}
              />
            );
          })}
        </Box>
        <Grid
          container
          spacing={2}
          sx={{
            px: 3,
            mt: 1,
            height: '62vh',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              height: '53vh !important',
            },
          }}
          className="scrollbar-cusgray"
        >
          {bookmarksData.length > 0 ? (
            <>
              {bookmarksData?.map((val: any) => {
                return (
                  <Grid item xs={12} sm={12} md={12} lg={3} xl={3}>
                    <JobCard value={val} saved={true} />
                  </Grid>
                );
              })}
            </>
          ) : (
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              <Box sx={{ marginTop: '100px' }}>
                <img src={jobImgNoFilter} height={'90px'} width={'78.65px'} />
                <Typography
                  sx={{
                    color: '#373A45',
                    fontSize: '15px',
                    fontWeight: 600,
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '12px',
                    },
                  }}
                >
                  Oops! There are no events with those filters.
                </Typography>
                <Typography
                  sx={{
                    color: '#373A45',
                    fontSize: '15px',
                    fontWeight: 400,
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '11px',
                    },
                  }}
                >
                  Try with another set of filters.
                </Typography>
              </Box>
            </Box>
          )}
        </Grid>
      </Paper>
    </div>
  );
};

export default SavedJobs;
